import React from "react";

export default function PreLoader({ message = "Loading..." }) {
  return (
    <div className="flex items-center justify-center min-h-[30vh] text-lg text-gray-700">
      <svg
        className="animate-spin mr-3 h-5 w-5 text-blue-500"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8z"
        ></path>
      </svg>
      {message}
    </div>
  );
}
